/*
 * Extract a value from a meta tag, usually placed in the head of the html
 */
export function getMetaTagContent(tagName: string): string | null {
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('property') === tagName) {
      return metas[i].getAttribute('content');
    }
  }

  return null;
}
